import { render, staticRenderFns } from "./AddCollegeInfo.vue?vue&type=template&id=484ec6e0&scoped=true&"
import script from "./AddCollegeInfo.vue?vue&type=script&lang=js&"
export * from "./AddCollegeInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddCollegeInfo.vue?vue&type=style&index=0&id=484ec6e0&prod&lang=scss&scoped=true&"
import style1 from "./AddCollegeInfo.vue?vue&type=style&index=1&id=484ec6e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ec6e0",
  null
  
)

export default component.exports